/**
 * Generazione di un'immagine per un blocco. Sta in un file suo perche' la usano in due:
 * il bottone "Genera" del selettore immagine (una foto sola, decisa dall'utente) e
 * l'assistente, che se le chiede da se' mentre compone la mail.
 *
 * Il caricamento passa dallo stesso endpoint dell'upload a mano: la foto generata entra
 * nella libreria del tenant come tutte le altre, e qui non nasce nessuna logica di
 * archiviazione nuova.
 */

// Tetto di immagini per singola richiesta all'assistente. Un'immagine costa circa quattro
// volte una risposta di testo: senza tetto, una frase distratta ne fa partire otto.
export var MAX_IMAGES_PER_REQUEST = 3

/**
 * Input:  axios, baseUrl del tenant, { prompt, templateId, ratio }
 * Fa:     chiede l'immagine al backend e la carica fra gli allegati del template
 * Output: promise di { url, cost, model, duration_ms }; url null se non e' tornata immagine
 */
export function generateImage(axios, baseUrl, opts) {
	return axios.post('ai/mail-marketing/image', {
		prompt: String(opts.prompt || '').trim(),
		template_id: opts.templateId,
		aspect_ratio: opts.ratio || null
	}).then(function(response) {
		var payload = response.data || {}
		return uploadGenerated(axios, baseUrl, opts.templateId, payload).then(function(url) {
			return { url: url, cost: payload.cost, model: payload.model, duration_ms: payload.duration_ms }
		})
	})
}

function uploadGenerated(axios, baseUrl, templateId, payload) {
	if (!payload.data) return Promise.resolve(null)

	var binary = atob(payload.data)
	var bytes = new Uint8Array(binary.length)
	for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)

	var mediaType = payload.media_type || 'image/png'
	var file = new File([bytes], 'ai-' + Date.now() + '.' + (mediaType.split('/')[1] || 'png'), { type: mediaType })

	var data = new FormData()
	data.append('file', file, file.name)
	data.append('attachable_type', 'template')
	data.append('attachable_id', templateId)
	data.append('public', 1)
	data.append('usage', 'email_image')

	return axios.post('attachments/', data).then(function(response) {
		return baseUrl + '/api/publicfiles/' + response.data.data.path
	})
}
